import { Link } from 'react-router-dom'
import { ArrowUpRight, Menu, X } from 'lucide-react'
import { useState, useEffect } from 'react'
import { cn } from '@/lib/utils'

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  // Close menu when screen size changes to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMenuOpen(false)
      }
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [isMenuOpen])

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <header className="w-full max-w-4xl pl-4 pr-4 md:pl-8 md:pr-8 lg:pl-12 lg:pr-44 py-5 flex items-center justify-between relative">
      <Link 
        to="/"
        className="text-foreground text-base font-semibold border-b border-dashed border-foreground border-opacity-50 hover:border-opacity-100 transition-all duration-300 pb-[2px]"
      >
        Sergey Tsibel
      </Link>

      {/* Mobile Menu Button with Animation */}
      <button
        className="md:hidden p-2 text-foreground hover:bg-foreground/5 rounded-lg transition-colors relative z-[60]"
        onClick={handleMenuToggle}
        aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={isMenuOpen}
      >
        <Menu className={cn(
          "h-6 w-6 absolute top-2 left-2 transition-all duration-300",
          isMenuOpen ? "opacity-0 rotate-90 scale-0" : "opacity-100 rotate-0 scale-100"
        )} />
        <X className={cn(
          "h-6 w-6 transition-all duration-300",
          isMenuOpen ? "opacity-100 rotate-0 scale-100" : "opacity-0 -rotate-90 scale-0"
        )} />
      </button>

      {/* Desktop Navigation */}
      <nav className="hidden md:flex items-center space-x-4">
        <Link 
          to="https://setolab.com"
          className="text-foreground text-base hover:underline inline-flex items-center"
          target="_blank"
          rel="noopener noreferrer"
        >
          Seto Lab
          <ArrowUpRight size={12} className="ml-1" />
        </Link>
      </nav>

      {/* Mobile Menu Overlay */}
      <div
        className={cn(
          "fixed inset-0 bg-[#ddd]/90 backdrop-blur-sm z-50 md:hidden transition-opacity duration-300",
          isMenuOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        )}
      >
        <nav className="flex flex-col h-full px-4 pt-24">
          <Link
            to="/"
            className={cn(
              "text-foreground text-2xl font-bold hover:text-foreground/80 transition-colors py-4",
              isMenuOpen && "animate-blur-in"
            )}
            onClick={() => setIsMenuOpen(false)}
          >
            Sergey Tsibel
          </Link>
          <Link 
            to="https://setolab.com"
            className={cn(
              "text-foreground text-2xl font-bold hover:text-foreground/80 transition-colors py-4 inline-flex items-center",
              isMenuOpen && "animate-blur-in"
            )}
            onClick={() => setIsMenuOpen(false)}
          >
            Seto Lab
            <ArrowUpRight size={16} className="ml-2" />
          </Link>
        </nav>
      </div>
    </header>
  )
}

export default Navigation 
